<template>
  <cargo-dialog
    :visible="visible"
    class="new-bill-payment-dialog"
    :title="$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees')"
    width="1100px"
    top="5vh"
    :can-maximize="source==='append'"
    :can-minimize="source==='append'"
    :source="source"
    @close="cancel"
  >
    <template>
      <native-query-charge
        v-if="!isQueryJob"
        ref="queryCharge"
        :show-simple="false"
        identify="queryCharge"
        view-source="billPayment_Create_Charge"
        :has-bill-payment="0"
        charge-state-param="BillPaymentChargeState"
        confirm-state-param="BillPaymentChargeConfirmState"
        job-state-param="BillPaymentJobState"
        :is-ar="defaultSearchConditions.isAr"
        :show-charge-count="showWindow"
        :check-verified-amount="true"
        :show-controlled-charge="false"
        :is-show-write-off="false"
        :new-by-job="2"
        :internal-charge="defaultSearchConditions.internalCharge"
        config-module="5082"
        grid-config-module="508201"
      >
        <template v-slot:searchAreaHeader>
          <span>{{ $t('Payment.inquiryWay') }}</span>
          <el-radio-group v-model="queryType" no="1" @change="onQueryTypeChange">
            <el-radio no="2" label="charge">{{ $t('Payment.accordingToCharge') }}</el-radio>
            <el-radio no="3" label="job">{{ $t('Payment.accordingToBusiness') }}</el-radio>
          </el-radio-group>
          <el-checkbox v-model="defaultSearchConditions.isAr" no="4" :true-label="-1" :false-label="0" style="margin-left: 10px;">{{ $t('Payment.includeReceivables') }}</el-checkbox>
          <el-checkbox v-show="useOrderCenterMode" v-model="defaultSearchConditions.internalCharge" no="5">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
          <span style="color: #ff0000;margin-left: 10px">{{ $t('Payment.couldNotSearhWriteOffJobFromThisWindow') }}</span>
        </template>
      </native-query-charge>
      <query-job-fast
        v-if="isQueryJob"
        ref="queryJob"
        :show-simple="false"
        identify="queryJob"
        view-source="billPayment_Create_Job"
        total-data-field="chargeAmount"
        total-currency-field="chargeCurrency"
        charge-state-param="BillPaymentChargeState"
        confirm-state-param="BillPaymentChargeConfirmState"
        job-state-param="BillPaymentJobState"
        :is-ar="defaultSearchConditions.isAr"
        :has-bill-payment="0"
        :show-charge-count="showWindow"
        :show-controlled-charge="false"
        :new-by-job="1"
        :internal-charge="defaultSearchConditions.internalCharge"
        config-module="5083"
        grid-config-module="508301"
      >
        <template v-slot:searchAreaHeader>
          <span>{{ $t('Payment.inquiryWay') }}</span>
          <el-radio-group v-model="queryType" no="6" @change="onQueryTypeChange">
            <el-radio no="7" label="charge">{{ $t('Payment.accordingToCharge') }}</el-radio>
            <el-radio no="8" label="job">{{ $t('Payment.accordingToBusiness') }}</el-radio>
          </el-radio-group>
          <el-checkbox v-model="defaultSearchConditions.isAr" no="9" :true-label="-1" :false-label="0" style="margin-left: 10px;">{{ $t('Payment.includeReceivables') }}</el-checkbox>
          <el-checkbox v-show="useOrderCenterMode" v-model="defaultSearchConditions.internalCharge" no="10">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
          <span style="color: #ff0000;margin-left: 10px">{{ $t('Payment.couldNotSearhWriteOffJobFromThisWindow') }}</span>
        </template>
      </query-job-fast>
    </template>
    <div slot="footer">
      <el-button
        no="11"
        type="primary"
        size="mini"
        @click="nextStep"
      >{{ $t('Payment.next') }}</el-button>
      <el-button
        no="12"
        size="mini"
        @click="cancel"
      >{{ $t('Payment.cancel') }}</el-button>
    </div>
  </cargo-dialog>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'

import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { queryChargeList } from '@/api/clearing/billingNative'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import nativeQueryCharge from '@/views/cargo/v0/Clearing/components/nativeQuery/nativeQueryCharge'
import queryJobFast from '@/views/cargo/v0/Clearing/components/query/queryJobFast'
import { cacheName, cache } from '@/utils/cacheManager'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import GlobalDialog from '@/utils/GlobalDialog'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'

export default {
  name: 'BillPaymentCreatorDialog',
  components: { CargoDialog, searchItem, nativeQueryCharge, queryJobFast, billPaymentDialog },
  props: {
    source: { type: String, default: '' },
    viewSource: { type: String, default: '' }, // 页面请求发起方 CARGO-33096 用来区分【付款申请】与【付款申请（新版）】
    location: { type: String, required: false }
  },
  data() {
    return {
      visible: false,
      openSapConfig: false,
      toExoSystemYGSH: false,
      step: '',
      queryType: 'charge', //
      innerVisible: this.visible,
      showWindow: false, // 是否显示右下弹框
      defaultSearchConditions: {
        isAr: 0, // 应收/应付
        advance: -1, //  是否垫付
        oversea: -1, // （国内/国外）
        hasInvoice: -1, // 是否开票
        hasDiffCharge: -1, // 是否关联差异对冲费用
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [], // 费用确认状态
        exceptKeys: [], // 在查询中想要例外的对象列表
        hasBillPayment: -1, // 是否关联付款申请
        hasBilling: -1, // 是否关联账单
        paidOff: -1, // 是包含以核销
        internalCharge: false // 内结
      },
      billPaymentDialog: { // 付款申请弹窗
        title: '',
        dialog: null
      }
    }
  },
  computed: {
    isQueryJob() {
      return this.queryType === 'job'
    },
    step1Visible() {
      return this.step === 'step1'
    },
    step2Visible() {
      return this.step === 'step2'
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.openSapConfig = Number(cache.config.get('openSapConfig')) === 1
    this.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
    this.showWindow = Number(cache.config.get('showChargeWindow')) === 1
    if (this.params && this.params.hasOwnProperty('title')) {
      this.title = this.params.title
    }
  },
  methods: {
    createBillPayment(parameter) {
      this.visible = true
    },
    onQueryTypeChange(val) {
      this.queryType = val
    },
    // 下一步按钮触发事件
    async nextStep() {
      // 装费用详情页数据
      let chooseRows = []
      if (!this.isQueryJob) { // 按费用校验
        chooseRows = this.$refs.queryCharge.getSelections()
        if (!chooseRows || chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectCharges'))
          return
        }
        // 验证结算对象全部相同
        if (!this.isSameAccount(chooseRows)) {
          this.$message.warning(this.$t('Message.SettleAccountMustBeSame'))
          return
        }
        if (!(await ClearingUtils.checkCreateBillPaymentByCharges(chooseRows))) return
        // // 验证应收费用不能大于应付费用
        // if (!this.checkBillPaymentCharge(chooseRows)) {
        //   this.$message.warning(this.$t('Message.ReceivableCannotMorethanPay'))
        //   return
        // }
        this.billPaymentDialog.title = this.$t('Clearing.CreatePaymentRequestDetailedInformation')
        this.step = 'step2'
        this.toStepTwo(chooseRows)
      } else { // 按业务校验
        chooseRows = this.$refs.queryJob.getSelections()
        if (!chooseRows || chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectJobs'))
          return
        }
        // 验证结算对象全部相同
        if (!this.isSameAccount(chooseRows)) {
          this.$message.warning(this.$t('Message.SettleAccountMustBeSame'))
          return
        } else {
          this.loadJobCharges(this.$refs.queryJob.getConditions(), chooseRows)
        }
      }
    },
    // 根据job查询符合付款申请的费用
    loadJobCharges(conditions, rows) {
      const jobKeys = []
      for (const job of rows) {
        if (job.uuid && jobKeys.indexOf(job.uuid) < 0) {
          jobKeys.push(job.uuid)
        }
      }
      // 组装高级查询调价
      conditions.push(new AdvancedSearchOption(null, 'job.UUID', jobKeys, OperatorConstants.OPERATOR_IN.code).formatObj2Json())
      if (!LoadDefaultQueryParam.isSelectOption(conditions, 'charge.ACCOUNT_ID')) {
        const option = new AdvancedSearchOption(null, 'charge.ACCOUNT_ID', rows[0].chargeAccountId, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }
      if (!LoadDefaultQueryParam.isSelectOption(conditions, 'charge.CURRENCY')) {
        const currencyArray = this.getCurrencyArray(rows)
        const option = new AdvancedSearchOption(null, 'charge.CURRENCY', currencyArray, OperatorConstants.OPERATOR_IN.code)
        conditions.push(option.formatObj2Json())
      }
      const requestBody = { paging: false, conditions, branchId: this.$store.getters.currentOfficeId, requestSource: 'billPayment_Create_Charge' }
      queryChargeList(requestBody).then(async(res) => {
        const charges = res.data.list
        if (charges && charges.length > 0) {
          // 验证结算对象全部相同
          if (!this.isSameAccount(charges)) {
            this.$message.warning(this.$t('Message.SettleAccountMustBeSame'))
            return
          }
          if (!(await ClearingUtils.checkCreateBillPaymentByCharges(charges))) return
          // // 验证应收费用不能大于应付费用
          // if (!this.checkBillPaymentCharge(charges)) {
          //   this.$message.warning(this.$t('Message.ReceivableCannotMorethanPay'))
          //   return
          // }
          this.billPaymentDialog.title = this.$t('Clearing.CreatePaymentRequestDetailedInformation')
          this.step = 'step2'
          this.toStepTwo(res.data.list)
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoChargeForBillPayment'))
          return
        }
      }).finally()
    },
    // 判断费用结算对象是否相同
    isSameAccount(rows) {
      const chargeAccount = rows[0].chargeAccountId
      for (let i = 1; i < rows.length; i++) {
        if (chargeAccount !== rows[i].chargeAccountId) {
          return false
        }
      }
      return true
    },
    // 校验整个付款申请的金额必须是应付
    // checkBillPaymentCharge(rows) {
    //   let c1 = 0
    //   let c2 = 0
    //   for (const charge of rows) {
    //     const businessDate = !charge.chargeInputDate ? charge.chargeDateCreated : charge.chargeInputDate
    //     const localCurrency = RateUtil.localCurrencyByOfficeId(charge.chargeBranchId)
    //     if (charge.chargeReceivable) {
    //       c1 += charge.chargeAmount * RateUtil.getForeignExchangeRateSafely(localCurrency, charge.chargeCurrency, businessDate)
    //     } else {
    //       c2 += charge.chargeAmount * RateUtil.getForeignExchangeRateSafely(localCurrency, charge.chargeCurrency, businessDate)
    //     }
    //   }
    //   return c1 === 0 || c2 - c1 >= 0
    // },
    // 组装业务费用所有币种
    getCurrencyArray(jobs) {
      const currencyArray = []
      for (const job of jobs) {
        if (currencyArray.indexOf(job.chargeCurrency) < 0) {
          currencyArray.push(job.chargeCurrency)
        }
      }
      return currencyArray
    },
    toPreStep(data) { // 上一步
      console.log(this.billPaymentDialog.dialog)
      this.billPaymentDialog.dialog.destroySelf()
      this.billPaymentDialog.dialog = null
      this.step = data
      this.mountDom()
    },
    cancel() {
      this.visible = false
      this.$emit('cancel')
      if (this.source === 'append') {
        console.log('销毁', this)
        if (this.isQueryJob) {
          this.$refs.queryJob.reSetProperties()
        } else {
          this.$refs.queryCharge.reSetProperties()
        }
      }
    },
    reloadData(data) {
      this.$emit('reloadData')
      const { instance } = this.billPaymentDialog.dialog
      instance.curBillPaymentUuid = data.uuid
    },
    toStepTwo(data) {
      this.removeDom()
      const propsData = {
        visible: true,
        title: this.billPaymentDialog.title,
        isDirectPayment: this.isDirectPayment,
        openSapConfig: this.openSapConfig,
        toExoSystemYGSH: this.toExoSystemYGSH,
        step: 'step2',
        mode: 'edit',
        viewSource: this.viewSource,
        location: this.location,
        showWht: this.$store.getters.currentOffice.whtTaxMode
      }
      this.billPaymentDialog.dialog = new GlobalDialog(billPaymentDialog, { propsData })
      const { instance } = this.billPaymentDialog.dialog
      instance.initBillPayment(data)
      instance.$on('toPreStep', this.toPreStep)
      instance.$on('cancel', this.cancel)
      instance.$on('reloadData', this.reloadData)
      instance.$on('saveSuccess', this.saveSuccess)
    },
    saveSuccess() {
      this.$emit('saveSuccess')
    }
  }
}
</script>
<style lang="scss">
.new-bill-payment-dialog {
  .el-radio {
    margin-right: 0;
    margin-left: 10px;
  }
}
</style>
